import React from 'react';
import useFormHandler from 'hooks/useFormHandler';
import { Button, DynamicForm } from 'components';
import { Props } from 'types/modals';
import Base from '../../base';
import schema from './schema';
import Badge from 'components/common/badge';

const AddRegisteredEmployeesModal = ({ closing, onClose, params }: Props) => {
  const formHandler = useFormHandler({
    employees: {
      ...schema.employees,
      endpointParams: { id: params.id },
      formatOptionLabel: (option: any) => (
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', whiteSpace: 'nowrap' }}>
            <span>{option.label}</span>
            <Badge variant="info" value={`ID: ${option.value}`} />
          </div>

          {option.errors && option.errors.length > 0 && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
              {option.errors.map((error: string, index: number) => (
                <Badge key={index} variant="danger" value={error} />
              ))}
            </div>
          )}
        </div>
      )
    }
  });

  const handleSave = () => {
    formHandler.setIsSubmitting(true);
    const employees = formHandler.data.employees.map((item: any) => +item.value);
    onClose(employees);
  };

  return (
    <Base
      header="Add registered employees"
      closing={closing}
      onClose={onClose}
      size="md"
      footer={
        <Button text="Save changes" disabled={!formHandler.valid || formHandler.isSubmitting} onClick={handleSave} />
      }
    >
      <DynamicForm handler={formHandler} />
    </Base>
  );
};

export default AddRegisteredEmployeesModal;
